"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ability_HellsFury_OnAttackedEventHandlerScript = void 0;
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Registries_1 = require("../../core/state/Registries");
let Ability_HellsFury_OnAttackedEventHandlerScript = class Ability_HellsFury_OnAttackedEventHandlerScript {
    run(sequence, container, handler, event) {
        if (!event.args.hit) {
            return;
        }
        container.applyDebuff({
            sequence,
            attackerId: handler.subject,
            targetId: event.args.attackerId,
            duration: Duration_1.Duration.Ticks(8),
            effect: new core_1.HellScornedEffectArgs(8),
        });
    }
};
Ability_HellsFury_OnAttackedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Ability_HellsFury_OnAttacked")
], Ability_HellsFury_OnAttackedEventHandlerScript);
exports.Ability_HellsFury_OnAttackedEventHandlerScript = Ability_HellsFury_OnAttackedEventHandlerScript;
